import { DEFAULT_EDITORS_FIT_DATA_ORDER } from "../../../../lib/utils/consts";
import DataPathSelector from './index';
const DataPathSelectorMeta = {
  id: 'dataPathSelector',
  component: DataPathSelector,
  isFormEditor: true,
  bindings: [{
    id: 'v-model',
    prop: 'value',
    event: 'change',
    main: true,
    required: true
  }],
  slots: [{
    id: 'actions',
    type: 'normal'
  }],
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'value',
      type: 'string',
      title: '当前值'
    }, {
      id: 'placeholder',
      type: 'string'
    }, {
      id: 'selectorOnly',
      type: 'boolean',
      title: '禁止直接输入path，只能选'
    }, {
      id: 'exampleVariableName',
      type: 'string',
      title: '(创建变量用) 默认变量名'
    }, {
      id: 'exampleSchema',
      type: 'any',
      title: '(创建变量用) 参考DataSchema'
    }]
  },
  events: [{
    id: 'change',
    name: '修改',
    desc: '数据发生修改时触发，$event 为新的值'
  }],
  fitData({
    dataSchema,
    dataPath
  }) {
    if (dataSchema.type !== 'string') return;
    return {
      type: 'editor',
      order: DEFAULT_EDITORS_FIT_DATA_ORDER + 1000,
      layout: {
        type: 'dataPathSelector',
        bindings: {
          'v-model': dataPath
        }
      }
    };
  }
};
export default DataPathSelectorMeta;
//# sourceMappingURL=meta.js.map
